<table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="$event ? toggleAllRows() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
      >
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)"
      >
      </mat-checkbox>
    </td>

    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'patient-details.authorization-card.attachments.table.file_name' | translate }}
      </th>
      <td mat-cell *matCellDef="let file">
        {{ file.fileName }}<br/>
        <small>{{ file.contentType }}</small>
      </td>
    </ng-container>

    <ng-container matColumnDef="dateUploaded">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'patient-details.authorization-card.attachments.table.date' | translate }}
      </th>
      <td mat-cell *matCellDef="let file">
        {{ file.lastModified | date: 'short' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let file">
        <button mat-icon-button (click)="viewFile({ event: $event, file: file })">
          <mat-icon>remove_red_eye</mat-icon>
        </button>
        <button mat-icon-button (click)="downloadFile({ event: $event, file: file })">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button
          mat-icon-button
          appConfirmClick
          [message]="'patient-details.authorization-card.attachments.table.delete-confirm' | translate"
          (confirm)="deleteFile(file)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
    </tr>
  </ng-container>
</table>

<div class="actions-container py-4 text-right">
  <ng-container *ngIf="selection.selected.length">
    <button
      mat-raised-button
      color="warn"
      appConfirmClick
      [message]="'patient-details.authorization-card.attachments.table.delete-confirm-multi' | translate: { count: selection.selected.length }"
      (confirm)="deleteSelectedFiles()">
      <mat-icon>delete</mat-icon>
      {{ 'patient-details.authorization-card.attachments.table.delete-selected' | translate: { count: selection.selected.length } }}
    </button>
  </ng-container>
</div>
